import React, { useContext } from 'react'
// @ts-ignore
import { Button, Flex, Heading, Text } from 'rebass'
import styles from './styles'
import {
  trackHandler,
  useUneeqState,
  UneeqContext,
  useDisableBodyOverflow
} from 'uneeq-react-core'
import useWidgetContext from '../../app/hooks/useWidgetContext'
import { MayaOverlay } from '../MayaOverlay'
import { useTranslation } from 'react-i18next'
interface MayaConfirmLeaveProps {
  onConfirm: () => any
}

const MayaConfirmLeave = React.memo(({ onConfirm }: MayaConfirmLeaveProps) => {
  const { confirmLeaveOpen } = useUneeqState()
  const { dispatch } = useContext(UneeqContext)
  const { t } = useTranslation()

  useDisableBodyOverflow(confirmLeaveOpen)

  const closeConfirmLeave = () => dispatch({ type: 'mayaCloseConfirmLeave' })
  const handleConfirm = () => {
    onConfirm()
    closeConfirmLeave()
  }

  if (!confirmLeaveOpen) return null

  return (
    <MayaOverlay>
      <Flex sx={styles.container}>
        <Heading sx={styles.heading}>{t('LeaveSession.title')}</Heading>
        <Text sx={styles.text}>{t('LeaveSession.subtitle')}</Text>
        <Flex sx={styles.buttonsContainer}>
          <Button
            variant="whiteInverted"
            onClick={trackHandler(handleConfirm, 'exit-session-btn')}
          >
            {t('LeaveSession.confirm')}
          </Button>
          <Button
            variant="primary"
            sx={styles.backToChatButton}
            onClick={closeConfirmLeave}
          >
            {t('LeaveSession.dismiss')}
          </Button>
        </Flex>
      </Flex>
    </MayaOverlay>
  )
})

export default MayaConfirmLeave
